module.exports = __webpack_public_path__ + "assets/img/00200.917d6973.png";